"use client"

export default function ScrollProgress() {
  return <div className="fixed top-0 left-0 right-0 h-0.5 bg-gradient-to-r from-cyan-400 to-blue-600 z-50" />
}
